module.exports = __webpack_public_path__ + "paynow.png?9ca81253a8bb6e2f0e7a1447d451a576";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/paynow.png
// module id = Zvep
// module chunks = 50